import { createBrowserRouter, redirect } from 'react-router-dom'
import axios from 'axios'

import LoginPage from '../pages/LoginPage'
import Dashboard from 'pages/Dashboard'
import AuthLayout from './AuthLayout' // Import the new layout

import { UserRoutes } from './routes/UsersRoutes'
import { ProfileRoutes } from './routes/ProfileRoutes'
import { LicenseRoutes } from './routes/LicensesRoutes'
import { ActivityRoutes } from './routes/ActivityRoutes'
import { SubscriptionRoutes } from './routes/SubscriptionRoutes'
import { ActivityHistoryRoutes } from './routes/ProfileSubRoutes/ActivityHistoryRoutes'
import { ResourceRoutes } from './routes/ResourcesRoutes'
import { MilestoneRoutes } from './routes/MilestoneRoutes'
import { BadgeRoutes } from './routes/BadgeRoutes'
import { base_url } from 'env'

const dashboardLoader = async () => {
  try {
    const [userRes, profileRes, licenseRes, subscriptionRes] =
      await Promise.all([
        axios.get(base_url + '/user/'),
        axios.get(base_url + '/profile/'),
        axios.get(base_url + '/license/'),
        axios.get(base_url + '/subscription/'),
      ])
    return {
      userCount: userRes.data.length,
      profileCount: profileRes.data.length,
      licenseCount: licenseRes.data.length,
      subscriptionCount: subscriptionRes.data.length,
    }
  } catch (error) {
    console.error('Dashboard loader error:', error)
    return {
      userCount: 0,
      profileCount: 0,
      licenseCount: 0,
      subscriptionCount: 0,
    }
  }
}

export default createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        loader: () => redirect('/dashboard'),
      },
      {
        path: 'dashboard',
        loader: dashboardLoader,
        element: <Dashboard />,
      },
      ...UserRoutes,
      ...ProfileRoutes,
      ...LicenseRoutes,
      ...ActivityRoutes,
      ...SubscriptionRoutes,
      ...ResourceRoutes,
      ...ActivityHistoryRoutes,
      ...MilestoneRoutes,
      ...BadgeRoutes,
    ],
  },
])
